import React, { useState, useRef, useEffect } from 'react'
import { Document, Page, pdfjs } from 'react-pdf';
import { Modal, Container, Grid } from '@mui/material'
import ArrowBackIosNewOutlinedIcon from '@mui/icons-material/ArrowBackIosNewOutlined';
import ArrowForwardIosOutlinedIcon from '@mui/icons-material/ArrowForwardIosOutlined';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';

pdfjs.GlobalWorkerOptions.workerSrc = `/pdf.worker.min.js`;

const PdfViewerModal = ({ blob, title, setViewer }) => {
    const [numPages, setNumPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);
    const [containerWidth, setContainerWidth] = useState(600); // Valor inicial
    const pdfAreaRef = useRef(null);

    const onClose = () => {
        setViewer(false);
        setPageNumber(1);
        setNumPages(null);
    };

    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
        setPageNumber(1);
    }

    const goToPrevPage = () => setPageNumber((prevPageNumber) => Math.max(prevPageNumber - 1, 1));
    const goToNextPage = () => setPageNumber((prevPageNumber) => Math.min(prevPageNumber + 1, numPages));

    useEffect(() => {
        function updateWidth() {
            if (pdfAreaRef.current) {
                setContainerWidth(pdfAreaRef.current.offsetWidth);
            }
        }
        updateWidth();
        window.addEventListener('resize', updateWidth);
        return () => window.removeEventListener('resize', updateWidth);
    }, [numPages]);

    if (!blob) {
        return null;
    }

    return (
        <Modal open={true} onClose={onClose} disableEscapeKeyDown={true}>
            <Container className="pdf-modal-container box-modal box-modal-lg" sx={{ backgroundColor: "#efefef"}} component="main">
                <Grid className="d-flex justify-content-between">
                    <h3>{title}</h3>
                    <button
                        onClick={onClose}
                        className="btn-padding-circle btn-red"
                    >
                        <CloseOutlinedIcon />
                    </button>
                </Grid>
                <div className="pdf-content-wrapper col-12">
                    <div className="text-center">
                        <div className="d-flex justify-content-center align-items-center">
                            <button className="btn-cancel" onClick={goToPrevPage} disabled={pageNumber <= 1}>
                                <ArrowBackIosNewOutlinedIcon className="" fontSize="14px" />
                            </button>
                            <span className="mx-3">{pageNumber} / {numPages}</span>
                            <button className="btn-cancel" onClick={goToNextPage} disabled={pageNumber >= numPages}>
                                <ArrowForwardIosOutlinedIcon className="" fontSize="14px" />
                            </button>
                        </div>
                    </div>
                    <div className='pdf-scroll-area col-12 mx-auto' ref={pdfAreaRef}>
                        <div className="">
                            <Document
                                file={blob}
                                onLoadSuccess={onDocumentLoadSuccess}
                                onLoadError={(error) => console.error('Error al cargar el documento:', error)}
                            >
                                <Page pageNumber={pageNumber} width={containerWidth - 32} />
                            </Document>
                        </div>
                    </div>
                </div>
            </Container>
        </Modal>
    );
};

export default PdfViewerModal;